import { gql } from "@apollo/client";

export const CREATE_USER = gql`
    mutation createUser($data: CreateUserInput!) {
        createUser(data: $data) {
            id
            name
            phone
            uid
            push_token
            role
            token_expires_at
        }
    }
`;

export const UPDATE_USER = gql`
    mutation updateUser($data: UpdateUserInput!) {
        updateUser(data: $data) {
            id
            name
            phone
            uid
            push_token
            role
            token_expires_at
        }
    }
`;

export const LOGIN = gql`
    mutation login($data: LoginUserInput!) {
        login(data: $data) {
            id
            name
            phone
            uid
            push_token
            token
            token_expires_at
            role
        }
    }
`;

export default CREATE_USER;
